import { store } from "Models/Store";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router";
import { CustomerApplicationPage } from "./Pages";
import { ApproveDashboardPage } from "./Pages/ApproveDashboardPage";
import CreateCustomerApplicationPage from "./Pages/CustomerApplication/CreateCustomerApplicationPage";
import EditCustomerApplicationPage from "./Pages/CustomerApplication/EditCustomerApplicationPage";
import CustomerApplicationDetailPage from "./Pages/CustomerApplicationDetailPage/CustomerApplicationDetailPage";
import PageAccessDenied from "./Pages/PageAccessDenied";
import PageNotFound from "./Pages/PageNotFound";

export interface FrontendApproveProps {
	path: string,
}

export function FrontendApprove(props: FrontendApproveProps) {
	document.title = 'Access Approve';

	if (!store.canAccessApprove) {
		return (
			<Switch>
				<Route path="/approve" component={PageAccessDenied} />
			</Switch>
		);
	}

	const isClientValidated = store.getUser?.organisation?.isValidated;

	const pages: {
		path: string,
		component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
		isAccessible?: boolean,
	}[] = [
		{
			path: '/approve/dashboard',
			component: ApproveDashboardPage,
			isAccessible: isClientValidated
		},
		{
			path: '/approve/customerapplications/add',
			component: CreateCustomerApplicationPage,
			isAccessible: isClientValidated
		},
		{
			path: '/approve/customerapplications/:id/edit',
			component: EditCustomerApplicationPage,
			isAccessible: isClientValidated
		},
		{
			path: '/approve/customerapplications/:id',
			component: CustomerApplicationDetailPage,
			isAccessible: isClientValidated
		},
		{
			path: '/approve/customerapplications',
			component: CustomerApplicationPage,
			isAccessible: isClientValidated
		},
	];

	const getAccessibleRoutes = () => {
		return pages
			.filter(page => page.isAccessible)
			.map(page => <Route key={page.path} path={page.path} component={page.component} />);
	};

	return (

		<Switch>
			<Redirect exact from="/approve" to="/approve/dashboard" />
			{getAccessibleRoutes()}
			{isClientValidated && <Route component={PageNotFound} />}
		</Switch>
	);
}